import { Component, Inject, OnInit, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Capability } from 'src/app/models/service/capability';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { SolutionVersionsService } from 'src/app/services/util/solution-versions.service';

@Component({
    selector: 'app-capability-details',
    templateUrl: './capability-details.component.html',
    styleUrls: ['./capability-details.component.scss'],
    standalone: false
})
export class CapabilityDetailsComponent implements OnInit {
  @Output() selectionChanged = new EventEmitter();

  mockedDocumentationData = [
    {
      title: 'Overview',
    },
    // {
    //   title: 'What Can I Do',
    // },
    // {
    //   title: 'User Guides',
    // },
    // {
    //   title: 'Integrations',
    // },
    // {
    //   title: 'Pricing',
    // },
    // {
    //   title: 'Release Notes',
    // }
  ];

  capability: Capability;
  selectable = true;
  description: string;
  version: any;
  releaseVersion: any;
  capabiltyDisabled: any;
  isAMR: any;
  selectedDocumentation: string;


  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private toastrService: CustomToastrService,
    private solutionVersionsService: SolutionVersionsService,
    public matdialogRef: MatDialogRef<CapabilityDetailsComponent>) {
    this.capability = data.capability;
    this.description = data.description;
    this.version = data.version;
    this.releaseVersion = data.releaseVersion;
    this.capabiltyDisabled = data.capabiltyDisabled;
    if (data.selectable != null) {
      this.selectable = data.selectable;
    }
    this.selectedDocumentation = this.mockedDocumentationData[0].title;
  }

  ngOnInit(): void {

    if(this.releaseVersion && this.solutionVersionsService.releaseVersion(this.releaseVersion)) {
      this.isAMR = true;
    }

  }

  selectDocumentation(documentation: any): void {
    this.selectedDocumentation = documentation.title;
  }

  toggleSelection(): void {
    this.capability.selected = !this.capability.selected;
    this.selectionChanged.emit(this.capability);
    this.selectionChangedData(this.capability);
    this.matdialogRef.close(this.capability);
  }

  selectionChangedData(changedCapability: Capability): void {
    const selectedCapabilities = [];
    selectedCapabilities.push(changedCapability);
    this.toastrService.clear();
  }

  titleCaseWord(word): void {
    if (!word) { return word; }
    return word[0].toUpperCase() + word.substr(1).toLowerCase();
  }
}
